const stylesServices = {
  div: {
    fontSize: "1rem",
    color: "darkgray",
    textAlign: "center",
    marginTop: "0.5rem",
  },
  divb: {
    width: "100%",
  },
  typography: {
    textAlign: "left",
    color: "black",
    marginTop: "1rem",
    opacity: "0.7",
    fontWeight: "bold",
    fontFamily: "Raleway,sans-serif"
  },
  typographyb: {
    width: "50%",
    marginTop: "1rem",
    fontFamily: "Raleway,sans-serif"
  },
  typographyc: {
    color: "black",
    marginLeft: "10rem",
    marginTop: "1rem",
    opacity: "0.7",
    fontFamily: "Raleway,sans-serif"
  },
  divc: {
    display: "flex",
    alignItems: "center",
  },
  typographyd: {
    color: "darkgray",
    textAlign: "center",
    marginLeft: "11rem",
    marginTop: "1.5rem",
    fontFamily: "Raleway,sans-serif"
  },
  a: {
    color: "blue",
    marginLeft: "15rem",
    marginTop: "1rem",
    textDecoration: "none",
    fontFamily: "Raleway,sans-serif"
  },
  typographye: {
    color: "darkgray",
    textAlign: "center",
    marginLeft: "7rem",
    marginTop: "1.5rem",
    fontFamily: "Raleway,sans-serif"
  },
  at: {
    color: "blue",
    marginLeft: "10rem",
    marginTop: "1rem",
    textDecoration: "none",
    fontFamily: "Raleway,sans-serif"
  },
  typographyf: {
    color: "darkgray",
    textAlign: "center",
    marginLeft: "5rem",
    marginTop: "1.5rem",
    fontFamily: "Raleway,sans-serif"
  },
  ac: {
    color: "blue",
    marginLeft: "6rem",
    marginTop: "1rem",
    textDecoration: "none",
    fontFamily: "Raleway,sans-serif"
  },
  dive: {
    marginTop: "1rem",
    textAlign: "right",
  },
  divf: {
    width: "50%",
    marginTop: "2rem",
  },
};

export default stylesServices;
